export const HEADERS = [
	'No.',
	'Name',
	'Buyer note',
	'Correction Reason',
	'Description',
	'Actions',
];
